import styled from 'styled-components/native'

export const Container = styled.View`
  height: 100%;
  justify-content: center;
  background-color: ${props => props.theme.colors.white};
  padding: 16px
`
